import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Base_Url } from '../config';
import { useSelector } from 'react-redux';

const EditContactInfo = () => {
  const userDataRedux = useSelector((state) => state.user.userData);
  // console.log(userDataRedux.user_id)
  const [contactInfo, setContactInfo] = useState({
    title: '',
    phone: '',
    email: '',
    location: '',
    updated_by: ''
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    fetchContactInfo();
  }, [id]);

  const fetchContactInfo = async () => {
    try {
      const response = await axios.get(`${Base_Url}/contact/${id}`);
      setContactInfo({
        ...response.data,
        updated_by: userDataRedux.userid
      });
      setLoading(false);
    } catch (err) {
      setError('Failed to fetch contact information');
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setContactInfo(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     await axios.put(`${Base_Url}/contact/${id}`, contactInfo);
  //     navigate('/contact'); // Redirect to contacts list page after successful update
  //   } catch (err) {
  //     setError('Failed to update contact information');
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const dataToSend = {
        ...contactInfo,
        updated_by: userDataRedux.userid
      };
      await axios.put(`${Base_Url}/contact/${id}`, dataToSend);
      navigate('/contact'); // Redirect to contacts list page after successful update
    } catch (err) {
      setError('Failed to update contact information');
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="alert alert-danger">{error}</div>;

  return (
    <div className="container mt-5">
      <h2 className="mb-4">Edit Contact Information</h2>
      <form onSubmit={handleSubmit} className="needs-validation" noValidate>
        <div className="form-group mb-3">
          <label htmlFor="title">Title:</label>
          <input
            type="text"
            className="form-control"
            id="title"
            name="title"
            value={contactInfo.title}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group mb-3">
          <label htmlFor="phone">Phone:</label>
          <input
            type="tel"
            className="form-control"
            id="phone"
            name="phone"
            value={contactInfo.phone}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group mb-3">
          <label htmlFor="title">location:</label>
          <input
            type="text"
            className="form-control"
            id="location"
            name="location"
            value={contactInfo.location}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group mb-3">
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            className="form-control"
            id="email"
            name="email"
            value={contactInfo.email}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit" className="btn btn-primary mb-5">Update Contact</button>
      </form>
    </div>
  );
};

export default EditContactInfo;
